import { render, staticRenderFns } from "./TourDefault.vue?vue&type=template&id=4dc7de2f&"
import script from "./TourDefault.vue?vue&type=script&lang=js&"
export * from "./TourDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports